// import './components/NativeImage'
// import TwIntersect from './lib/twIntersect'
import './components/Header'
import './components/Carousel'
import './components/NavActive'
import './components/NavSmooth'

// Initialize Tailwind intersection observer
// new TwIntersect().init()

